import React from 'react';



function Ourvision1() {
    return (
        <section className="skill-section bg-grey padding">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="video-wrap">
                            <img src="assets/img/post-10.jpg" alt="img" />
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="section-heading mb-30">
                            <h2 className="text-anim" data-effect="fade-in-right" data-split="char" data-delay="0.3" data-duration={1}> Our Vision </h2>
                            <p className="text-anim" data-effect="fade-in-bottom" data-ease="power4.out">At <span style={{color : '#0A0909', fontWeight : 'bold'}}>TITA Technologies</span>, we aspire to revolutionize the IT landscape by creating a world where technology drives limitless possibilities. Our vision is to become a global leader in <span style={{color: '#0A0909', fontWeight: 'bold'}}>IT Training, IT Staffing,  </span> and <span style={{color: '#0A0909', fontWeight: 'bold'}}>Project Services,</span> helping businesses innovate, grow, and thrive in the digital era.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Ourvision1;